module.exports = "<div class=\"yeti-tab-item active\" *ngIf=\"active\">\r\n\r\n    <ng-content></ng-content>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/reusable-components/tab-menu/tab-item.html
// module id = 678
// module chunks = 0